import { ImageSelectorContainer as Container } from "src/components/imageSelector/ImageSelectorContainer";
import { ImageSelectorItem as Item } from "src/components/imageSelector/ImageSelectorItem";

export const ImageSelector = {
    Item,
    Container,
};